/* c8 ignore start */
import { i18n } from "@/i18n.js";
import { SIDENAV_GROUP_BY } from "@/constants";
import { PHISHING_SIMULATION } from "@/utils/services";
import { buildOrgUrl } from "@/utils/navigation/orgUrl";

export const MSP_NAV_ITEMS = [
  {
    order: 2,
    groupBy: SIDENAV_GROUP_BY.BETA,
    label: i18n.global.t("sidebar-phishing-simulation"),
    name: "msp-phishing-simulation",
    icon: "cb-icon-phishing",
    id: buildOrgUrl("msp", undefined, "phishing_simulation"),
    dataTestId: "msp-phishing_simulation",
    solutionId: PHISHING_SIMULATION,
    children: [
      {
        label: i18n.global.t("sidebar-email-sec-overview"),
        id: buildOrgUrl("msp", undefined, "phishing_simulation/overview"),
        dataTestId: "msp-phishing_simulation-overview",
      },
      {
        label: i18n.global.t("Phishing Campaigns"),
        id: buildOrgUrl(
          "msp",
          undefined,
          "phishing_simulation/phishing_campaigns",
        ),
        dataTestId: "msp-phishing_simulation-phishing_campaigns",
      },
    ],
  },
];

export const CUSTOMER_NAV_ITEMS = [
  {
    order: 2,
    groupBy: SIDENAV_GROUP_BY.BETA,
    label: i18n.global.t("sidebar-phishing-simulation"),
    icon: "cb-icon-phishing",
    id: buildOrgUrl("customer", undefined, "phishing_simulation"),
    dataTestId: "customer-phishing_simulation",
    solutionId: PHISHING_SIMULATION,
    children: [
      {
        label: i18n.global.t("sidebar-email-sec-overview"),
        id: buildOrgUrl("customer", undefined, "phishing_simulation/overview"),
        dataTestId: "customer-phishing_simulation-overview",
      },
      {
        label: i18n.global.t("Phishing Campaigns"),
        id: buildOrgUrl(
          "customer",
          null,
          "phishing_simulation/phishing_campaigns",
        ),
        dataTestId: "customer-phishing_simulation-phishing_campaigns",
      },
    ],
  },
];
/* c8 ignore end */
